var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseyShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 188.12 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9e7eb;}.cls-2{fill:#6eb9c7;}.cls-3{fill:#57a7b3;}.cls-4{fill:url(#Degradado_sin_nombre_4);}.cls-5{fill:#4b9ea6;}.cls-6{fill:#3b656c;}.cls-7,.cls-9{fill:#fff;}.cls-8{fill:url(#Degradado_sin_nombre_9);}.cls-9{opacity:0.37;}.cls-10{fill:#76b4c0;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_4",
    x1: 238.87,
    y1: 32.72,
    x2: 122.04,
    y2: 118.43,
    gradientTransform: "translate(-2.31 -25.82) rotate(-1.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#e5f2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#b2dae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8dc8d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#76bdca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6eb9c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_9",
    x1: 47.16,
    y1: 104.96,
    x2: 183.36,
    y2: 128.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fafdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#afd8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#80c2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6eb9c7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 108.59,
    cy: 192.06,
    rx: 56.42,
    ry: 7.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.26,150.66C85,155.9,79.85,163.32,82.77,176.75c-11.59-2.11-21.28,0-23.78,13.21h0c14.06,10.89,29.73,4.64,43.83-3.73-8-15.58-16.25-17.92,0-31.56Q100.05,152.66,97.26,150.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.79,189.71c0-3.4,3.55-10.71,12.67-13.66-8.19.06-14.52,3.62-16.47,13.91h0a26.49,26.49,0,0,0,19.28,5.69h0S68,194.69,62.79,189.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.77,176.75l-.16,0c1,.62,3.1,1.88,6,3.61-7.46-7.27-4.4-18.76,4.22-25.08,1.91.19,10-.57,10-.57q-2.76-2-5.55-4C85,155.9,79.85,163.32,82.77,176.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.21,150.14c12.32,5.25,17.41,12.67,14.49,26.1,11.59-2.11,21.28,0,23.78,13.21,0,0,0,0,0,0-14.07,10.89-29.73,4.64-43.84-3.73,8-15.58,16.25-17.92,0-31.56C116.51,152.82,118.35,151.48,120.21,150.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.44,195c0-.06.05-.1.06-.16-13.21,0-19-4-25.85-12.25,0,0,3.45-4.21,5.55-12.45l2.11,2.11c.19-2.68.38-7.28-5.55-14.55l8.65-1.13-.33-.33-8.66-5.58c-.4-.19-.79-.38-1.21-.56-1.86,1.34-3.7,2.68-5.55,4,16.23,13.64,8,16,0,31.56C124.5,191.58,135.13,196.39,145.44,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.37,10.08c-5.45,4.72-4.92,10-4.92,10s36,33.05,52.67,65.43c-4,2.88-10.42,4.69-12.48,5.22a1.08,1.08,0,0,0-.79.83c-1.08,5.27-8.46,39.74-16.87,64.88-9.11,1.93-68.37-.65-93.66-7.85a0,0,0,0,1,0,0c-7.06-41.74-9.12-68.44-9.17-69.67-6.72-1-14.29-6.73-15.24-7.87h0c30.42-37.41,68.2-53.6,68.25-53.62h0C104,6.26,117.13,0,117.14,0h0c.63,9.67,5.36,15.25,5.4,15.29h0C127.63,5.56,140.37,10.08,140.37,10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M158.57,123a23.45,23.45,0,0,0-4.85-4.74c.52-3.89,3.74-13.5-2.89-13.78s-6.86,9.8-3.72,14a24,24,0,0,1-6.44-1.38c-3.25-1.38-10.72-9-14.28-3.84s5.37,9.8,10.06,10.42a7.33,7.33,0,0,0-.86,3c-3.94-.47-14.36-3.94-14.93,2.86s10.76,5.07,15.2,3.82a9.35,9.35,0,0,1,.61,2.42c-.64.2-1.52.39-2.5.61-3.86.87-9.29,2.25-7.61,6.72,2.12,5.61,9.56,2.13,13.17-1.05,9.46,5.07,15.53,2.51,22.89-4.59l1.36-.14c1.29-4.64,2.52-9.29,3.65-13.75C165.76,124.19,163,124.13,158.57,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.79,129.07a26.61,26.61,0,0,0,28.73-24.23,3.51,3.51,0,0,0-7-.6,19.56,19.56,0,1,1-39-3.31,3.51,3.51,0,1,0-7-.59A26.61,26.61,0,0,0,104.79,129.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M131.82,61.71a3.06,3.06,0,0,0,1.25-.22,3.13,3.13,0,0,0,1.72-4.06,12.32,12.32,0,0,0-16.19-6.88,3.12,3.12,0,1,0,2.33,5.78A6.07,6.07,0,0,1,129,59.77,3.12,3.12,0,0,0,131.82,61.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.13,60.33A3.14,3.14,0,0,0,94,58.47a6.07,6.07,0,0,1,8.19-3.17,3.12,3.12,0,1,0,2.52-5.7A12.31,12.31,0,0,0,88.3,56a3.11,3.11,0,0,0,1.59,4.11A3,3,0,0,0,91.13,60.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.16,76.56a6.84,6.84,0,1,0,5.6-7.88A6.83,6.83,0,0,0,112.16,76.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.28,73.5a1.91,1.91,0,1,0,1.59-2.18A1.91,1.91,0,0,0,120.28,73.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 99.79,
    cy: 73.81,
    r: 6.84,
    transform: "matrix(0.38, -0.92, 0.92, 0.38, -6.56, 137.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.12,72.1a1.91,1.91,0,1,0,1.51-2.24A1.91,1.91,0,0,0,101.12,72.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.53,101.74l-2.68,11.4c3,5.78,3,11-9.24,7.82a23.45,23.45,0,0,0-4.85-4.74c.52-3.89,3.74-13.5-2.89-13.78s-6.86,9.8-3.73,14A24.53,24.53,0,0,1,142.7,115c-3.24-1.39-10.71-9-14.27-3.85s5.37,9.8,10.06,10.42a7.37,7.37,0,0,0-.86,3c-3.94-.48-14.36-3.95-14.93,2.85s10.76,5.07,15.2,3.82a9.35,9.35,0,0,1,.61,2.42c-.64.2-1.52.39-2.5.61-3.86.88-9.29,2.25-7.61,6.72,2.12,5.61,9.56,2.13,13.17-1.05,9.46,5.07,15.53,2.51,22.89-4.59C189.3,133.52,188.39,116.08,172.53,101.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M174.31,103.44c11.35,12.74,12,26.76-3.95,31.1C188.22,130.68,187.14,116.16,174.31,103.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156,106.71a20.28,20.28,0,0,1-.22,4.19,39,39,0,0,1-.84,5,.48.48,0,0,1-.35.36,4.17,4.17,0,0,0-1,.25,13.56,13.56,0,0,1,4.65,2,14.79,14.79,0,0,1,2.31,2.37l.13,0a23.72,23.72,0,0,0-4.83-4.71c.49-3.68,3.39-12.49-1.93-13.65A5.61,5.61,0,0,1,156,106.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.45,111.37c-.27-.4-4.75,5.65-10.1,3.83-8.65,2.35-17.38-4-14.89-9.33-1.61-1.05-7.11-4.33-.64-11.06C1.46,92.88-2,88.51,1.23,82.74s13.38,3.61,18.07,6.1a26.88,26.88,0,0,0,5.88,1.28c-.29-2.67-4.72-5.19-3.16-9.87s7.89-3.51,8.86,0S34.56,89,35.41,94.32c6.46,7.74,16.26,5.85,23.83-.42,7.25-.64,3.1,8.51,3.1,8.51C50.54,120.53,38.66,114.53,34.45,111.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.92,127.11a4.06,4.06,0,0,0,.39.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.69,116.32c-4.31-3.54-5.06-10.19-.86-13.58-4.59,1.67-4.46,10-1.69,13.66h-.08A4.85,4.85,0,0,0,151.69,116.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.91,126.33l0,.06,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M144.09,139.61a14.3,14.3,0,0,0,.13-2.17,28.61,28.61,0,0,1-2.65,2.53c8.84,4.74,14.73,2.81,21.47-3.27C156.22,142.43,147.31,141,144.09,139.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.85,113.14c3,5.78,3,11-9.24,7.82,0,0,8.25,3,10.8.66,1.8-1.62,2.26-4.51-1.26-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M129.85,132.43h0a50.16,50.16,0,0,0,7.67-1.06l.37-.1v0h0c.05.17.09.34.14.51a10.3,10.3,0,0,1,.32,1.24l.15.66-.31.06-1,.25h0a12.88,12.88,0,0,1,3.38.58,11.11,11.11,0,0,1-1.76-5.85c-4.09,5.25-16.13,2.32-16-2.35l0,0h0a5,5,0,0,0-.2,1.09C122.37,131.32,125.92,132.43,129.85,132.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128,112a3.51,3.51,0,0,0-.25.73,4.64,4.64,0,0,0,.56,3.11h0a7.81,7.81,0,0,0,.53.75c2.16,2.67,6.75,4.61,9.68,5l0,0h0a7,7,0,0,0-.46,1h0a7.62,7.62,0,0,0-.3,1.11,4.49,4.49,0,0,0-.06.91l1.23,2.49c-.9-2.34.41-5.18,1.4-7.22-3,.06-5.17.17-7.94-1.79s-6.15-7.22-.56-8.51a4.07,4.07,0,0,1-1.57.07h0a3.88,3.88,0,0,0-.46.22l-.08.05a2.7,2.7,0,0,0-.36.26l-.11.08a3.11,3.11,0,0,0-.32.31l-.11.11a4.88,4.88,0,0,0-.38.49,5,5,0,0,0-.42.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M130.44,142.42c-2.13-2.12.28-5.58,4.56-7.88h0l-.67.16-.11,0-.6.17-.18,0-.55.16-.16.06c-.29.09-.57.19-.85.3l-.38.15-.29.13-.38.17-.27.15-.35.2-.25.16a3.62,3.62,0,0,0-.32.22l-.22.18-.27.24-.19.2-.22.27a1.43,1.43,0,0,0-.15.22,1.87,1.87,0,0,0-.17.31,1.63,1.63,0,0,0-.11.23c0,.11-.08.23-.11.34l-.06.25a2.56,2.56,0,0,0,0,.39,2.28,2.28,0,0,0,0,.26,4,4,0,0,0,.06.47,2,2,0,0,0,0,.24,5,5,0,0,0,.22.77c2.12,5.61,9.56,2.13,13.17-1.05C138.67,142.36,132.61,144.59,130.44,142.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.81,93.41c4.09,2.93,1.15,7.15,1.15,7.15l-.89.12C18.37,97.24,17.41,94.8,15.81,93.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.46,77.23a4.28,4.28,0,0,0-3.44,3c-1.56,4.68,2.87,7.2,3.16,9.87l-.51-.05a16.06,16.06,0,0,0,3.78,1.17c2,.25-2.17-1.15-2.17-1.15A8.85,8.85,0,0,0,25.13,87s1,.25,3.07-.9C21.89,86.75,22.3,80.2,25.46,77.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.62,111.28s.38-3.45-1.79-5.24c.64,1.28.39,3.71-.38,5.33,3.72,2.79,13.42,7.79,23.76-3.57,0-.2.08-.4.11-.61C49.9,115.62,40.83,113.7,36.62,111.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.82,94.81C0,91.23.63,82.3,5.35,81.15c.17,0,.89.15,1.93.38-2.55-1-4.8-1-6.05,1.21C-2,88.51,1.46,92.88,8.82,94.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.46,105.87C7,111.23,15.7,117.55,24.35,115.2c4.21,1.43,7.87-2,9.37-3.33-3.22,2-7.91,3-9.1,1.32-4.85,3.7-12.25-.25-13.15-3.83s2.06-9,6.39-8.55c-2.6-1-5.43.73-7.79,4.09C3.43,98.77,12,91.45,15.81,93.41c-1.53-1.53-5.48-.13-7,1.4C2.35,101.54,7.85,104.82,9.46,105.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.86,100.81a4.61,4.61,0,0,1-.4,7.68C21.86,106.76,20.65,101.66,17.86,100.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.1,39.8s-5.36-1.15-14.17,3.44c1.53-4.21,14.55-15.7,36.38-27.57a49.14,49.14,0,0,0-6.51.39A20.27,20.27,0,0,1,117.14,0h0s-13.14,6.27-9,17.43h0c-.05,0-37.83,16.21-68.25,53.62h0c1,1.14,8.52,6.83,15.24,7.87,0,1.23,2.11,27.93,9.17,69.67a0,0,0,0,0,0,0c10.53,3,27,5.2,43.19,6.6C44.2,124.07,67.38,54.73,96.1,39.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.37,10.08C130.56,13.38,129,21.8,129,21.8c13.41,8,51.7,51.31,51.7,51.31l0-.12C162.69,45.15,135.45,20.1,135.45,20.1S134.92,14.8,140.37,10.08Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseyShow);
export default __webpack_public_path__ + "static/media/housey-show.1dbb523d12423a1c3b9d749cfce73233.svg";
export { ForwardRef as ReactComponent };